import React, { Component } from 'react';
import {
  Table,
  Segment,
  Grid,
  Label,
  Divider,
  Icon,
  Popup,
  Button
} from 'semantic-ui-react';

class CampaignTagsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCampaignTagObjects: []
    };
  }

  componentDidMount() {
    const { onRef, campaignKey } = this.props;
    this.setCurrentCampaignForTable(campaignKey);
    if (onRef) onRef(this);
  }

  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) onRef(undefined);
  }

  setCurrentCampaignForTable = (campaignKey = '') => {
    const { campaignTagsObjects } = this.props;
    let currentCampaignTagObjects = campaignTagsObjects;
    if (campaignKey.trim() !== '') {
      currentCampaignTagObjects = campaignTagsObjects.filter(
        (campaignTagsObject) => {
          return campaignTagsObject.campaignObjective === campaignKey;
        }
      );
    }

    this.setState({ currentCampaignTagObjects });
  };

  renderCampaignTagsTable = (campaignTagsObject) => {
    const { campaignName, campaignTags } = campaignTagsObject;
    if (campaignTags && campaignTags.length > 0) {
      return (
        <Table color="yellow" compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{campaignName} Tags</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {campaignTags.map((campaignTag) => (
              <Table.Row>
                <Table.Cell>{campaignTag.name}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      );
    }
    return null;
  };

  renderHecWarningLabels = (campaignTagsObjects = []) => {
    const hecCampaignTagObjs = campaignTagsObjects.filter(
      (campaignTagObj) => campaignTagObj.campaignSpecialAdCat !== 'NONE'
    );

    const hecLength = hecCampaignTagObjs.length;

    const nonHecCampaignTagObjs = campaignTagsObjects.filter(
      (campaignTagObj) => campaignTagObj.campaignSpecialAdCat === 'NONE'
    );

    const nonHecLength = nonHecCampaignTagObjs.length;

    const columns = hecLength <= 0 || nonHecLength <= 0 ? 1 : 2;

    return (
      <Popup
        wide="very"
        position="top right"
        trigger={
          <Button basic color="grey">
            {/* <div style={{ float: 'left' }}>
              <Icon name="check  circle" color="teal" />
              {hecLength}
            </div>
            <div style={{ float: 'right', marginLeft: '0.5em' }}>
              <Icon name="warning circle" color="yellow" />
              {nonHecLength}
            </div> */}
          </Button>
        }
        on={'click'}
        hideOnScroll
      >
        <Popup.Content>
          <Grid stackable columns={columns} divided="vertically">
            <Grid.Row style={{ paddingBottom: 0 }} textAlign="center">
              {hecLength > 0 ? (
                <Grid.Column>
                  <div>
                    <Icon name="check  circle" color="teal" />
                    HEC compliant
                  </div>
                </Grid.Column>
              ) : null}
              {nonHecLength > 0 ? (
                <Grid.Column>
                  <div>
                    <Icon name="warning circle" color="yellow" />
                    Not HEC compliant
                  </div>
                </Grid.Column>
              ) : null}
            </Grid.Row>
            <Grid.Row
              divided
              columns={columns}
              style={
                columns > 1
                  ? { paddingTop: 0, fontSize: 11 }
                  : { paddingTop: 0 }
              }
            >
              {hecLength > 0 ? (
                <Grid.Column>
                  {hecCampaignTagObjs.map((campaignTagObj) => (
                    <div>{campaignTagObj.campaignName}</div>
                  ))}
                </Grid.Column>
              ) : null}
              {nonHecLength > 0 ? (
                <Grid.Column>
                  {nonHecCampaignTagObjs.map((campaignTagObj) => (
                    <div>{campaignTagObj.campaignName}</div>
                  ))}
                </Grid.Column>
              ) : null}
            </Grid.Row>
          </Grid>
        </Popup.Content>
      </Popup>
    );
  };

  renderCampaignsTagsContainer = () => {
    const { currentCampaignTagObjects } = this.state;

    const currentLength = currentCampaignTagObjects.length;

    return (
      <div>
        <Segment>
          <Label
            style={currentLength < 1 ? { opacity: 0.5 } : { opacity: 1 }}
            color="yellow"
            ribbon="left"
          >
            Campaign Info
          </Label>
          <Grid stackable>
            {currentLength > 0 ? (
              <Grid.Row style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                <Grid.Column textAlign="right">
                  {this.renderHecWarningLabels(currentCampaignTagObjects)}
                </Grid.Column>
              </Grid.Row>
            ) : null}
            <Grid.Row columns="equal">
              {currentCampaignTagObjects.map((campaignTagsObject) => (
                <Grid.Column width={2} style={{ fontSize: 11 }}>
                  {this.renderCampaignTagsTable(campaignTagsObject)}
                </Grid.Column>
              ))}
            </Grid.Row>
          </Grid>
        </Segment>
        <Divider hidden />
      </div>
    );
  };

  render() {
    return this.renderCampaignsTagsContainer();
  }
}

export default CampaignTagsContainer;



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/CampaignTagsContainer.js